import { toRiotLocale } from "@/utils/rioti18n";
import siteConfig from "@/variables";
import {
  Configuration,
  ContentCodeClaimRequest,
  ContentCodesApiFactory,
} from "@riot-private/commerce-contentcodes-client/lib";

export type ContentCodeParams = {
  accessToken: string;
} & ContentCodeClaimRequest;

const getApiFactory = (accessToken: string) => {
  const config = new Configuration({
    basePath: siteConfig.CONTENTCODES_API_BASE,
    accessToken: accessToken,
  });
  return ContentCodesApiFactory(config);
};

export const validateCode = async ({ code, locale, accessToken }: ContentCodeParams) => {
  const apiFactory = getApiFactory(accessToken);

  const { data } = await apiFactory.validateContentCode({ code, locale: toRiotLocale(locale) });

  return data;
};

export const getCodeStatus = async ({ code, locale, accessToken }: ContentCodeParams) => {
  const apiFactory = getApiFactory(accessToken);

  const { data } = await apiFactory.getContentCodeStatus({ code, locale: toRiotLocale(locale) });

  return data;
};

export const claimCode = async ({ code, locale, accessToken }: ContentCodeParams) => {
  const apiFactory = getApiFactory(accessToken);

  const { data } = await apiFactory.claimContentCode({ code, locale: toRiotLocale(locale) });

  return data;
};
